import { render, staticRenderFns } from "./LinkFileV3.vue?vue&type=template&id=a39d55fa&"
import script from "./LinkFileV3.vue?vue&type=script&lang=js&"
export * from "./LinkFileV3.vue?vue&type=script&lang=js&"
import style0 from "./LinkFileV3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports